export default class PollutionSourceActivityDto {
    constructor(obj) {
        this.activityCode = obj.activityCode
        this.rate = obj.rate
        this.parameterCode = obj.parameterCode
    }
}